





























import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, State, Action } from "vuex-class";
import OrderItem from "./TradeOrderItem.vue";
import EmptyOrderList from "./EmptyOrderAction.vue";

@Component({
  components: {
    OrderItem,
    EmptyOrderList
  }
})
class AutoOrderList extends Vue {
  @Getter("trade/orders/getGroupedAutoOrders") groupedOrders;

  @Action("trade/orders/loadAutoOrders") loadAutoOrders;

  @State(state => state.trade.orders.auto.hasNext) hasNext;

  @State(state => state.trade.orders.auto.data) orders;

  @Prop() strategy;

  loading = false;

  get empty() {
    return this.orders.length === 0 && !this.loading;
  }

  get loadMoreDisabled() {
    return !this.hasNext || this.loading;
  }

  mounted() {
    this.loadData(true);
  }

  async loadData(refresh = false) {
    this.loading = true;
    await this.loadAutoOrders({
      refresh,
      params: { strategy: this.strategy }
    });
    this.loading = false;
  }

  handleToOrder(order) {
    this.$helper.toFusionPath(this, "trade", {
      name: "orders-id",
      params: { id: order.id }
    });
  }
}
export default AutoOrderList;
